// extracted by mini-css-extract-plugin
export default {"root":"AvatarImage_root__PucD-"};